import { ApiPromise } from 'app/scripts/network/api-promise';

export interface TrelloUser {
  active: boolean;
  activityBlocked: boolean;
  avatarHash?: string;
  avatarUrl?: string;
  email?: string;
  fullName: string;
  id: string;
  idBoards: string[];
  idOrganizations: string[];
  initials: string;
  username: string;
}

export const getTrelloUsers = (
  query: string,
  orgId: string,
  idboard: string,
): Promise<TrelloUser[]> => {
  return ApiPromise({
    url: '/1/search/members/',
    type: 'get',
    data: {
      query: query,
      idBoard: idboard,
      idOrganization: orgId,
    },
    dataType: 'json',
  });
};
